var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var UsageActivity_1;
import { DateConverter, JSON, JsonConverter, JsonDiscriminatorValue, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import { Activity } from './activity';
import { usageActivitySchema } from './jsonSchemas/usageActivity';
import { usageActivitySchemaValidation } from '../validations.generated';
import { ActivityType } from './activityType';
// 2.19 new usage accounting via WP-5608: 1 CPU/min = 1 credit
// Python uses 1 CPU max
const PythonMsCost = -1 / 60000; // 60 sec/min, 1000 ms/sec
// Spark configuration is dynamic - see aws-emr-spark/README.md
// Without additional info, we have hard coded the value for all environments
// (whether scaling is enabled or not, and no matter what is happening dynamically
// with the number of executors).
const SparkMsCost = PythonMsCost * 2;
let UsageActivity = UsageActivity_1 = class UsageActivity extends Activity {
    constructor(activityID, date, value, details, orgID, userID, orgPlan, charge, lastRefresh) {
        super(activityID, ActivityType.Usage, date, value, details, orgID, userID, orgPlan);
        this.charge = charge;
        this.lastRefresh = lastRefresh;
        JSON.validate(this, UsageActivity_1);
    }
    /** Return the charge based on details and value as ms units of time used */
    static getUsageDelta(details, value) {
        if (details.length > 0 && details[0] === 'Compute') {
            // convert milliseconds of usage into credit charges
            if (details.length > 1) {
                let chargePerMs = 0;
                // We only charge for Compute - everything else is free
                if (details[1] === 'Spark') {
                    chargePerMs = SparkMsCost;
                }
                else if (details[1] === 'Python') {
                    chargePerMs = PythonMsCost;
                }
                return value * chargePerMs;
            }
        }
        // Non-Compute rate is 0
        return 0;
    }
};
__decorate([
    JsonConverter(new DateConverter('date-time'))
], UsageActivity.prototype, "lastRefresh", void 0);
UsageActivity = UsageActivity_1 = __decorate([
    JsonSchemaV2(usageActivitySchema, usageActivitySchemaValidation),
    JsonDiscriminatorValue(ActivityType.Usage)
], UsageActivity);
export { UsageActivity };
//# sourceMappingURL=usageActivity.js.map